import { Button, Modal } from "react-bootstrap";
import React, { useState, useEffect } from "react";

const ModalLiquidar = (props) => {
  const { estado, onCloseModal, onReturnValue, estadoliquidacion, datos } = props;
  // Inicialización con nuevo campo fechaordenpago
  const [formData3, setValue] = useState({
    estado: estadoliquidacion || "CIERRE",
    facturanumero: "",
    montoliquidado: "",
    obs: "",
    fechaordenpago: "", // nuevo campo
  });

  const handleSubmit2 = (event) => {
    event.preventDefault();
    const envio = {
      ...formData3,
      estado: formData3.estado || "CIERRE",
    };
    onReturnValue(envio);
  };

  useEffect(() => {
    if (estado) {
      if (datos) {
        setValue({
          estado: datos.estado || "CIERRE",
          facturanumero: datos.facturanumero || "",
          montoliquidado: datos.montoliquidado || "",
          obs: datos.obs || "",
          fechaordenpago: datos.fechaordenpago || "", // carga si existe
        });
      } else {
        setValue({
          estado: estadoliquidacion || "CIERRE",
          facturanumero: "",
          montoliquidado: "",
          obs: "",
          fechaordenpago: "",
        });
      }
    }
  }, [estado, estadoliquidacion, datos]);

  return (
    <Modal show={estado} onHide={onCloseModal} size="m">
      <Modal.Header closeButton>
        <Modal.Title>Liquidar</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form>
          <div className="form-group mb-2 row">
            <label className="col-form-label">
              Estado
              <span className="text-danger">*</span>
            </label>
            <div>
              <select
                className="form-control"
                value={formData3.estado}
                onChange={(e) =>
                  setValue({ ...formData3, estado: e.target.value })
                }
              >
                {estadoliquidacion === "A ORDEN DE PAGO" ? (
                  <>
                    <option value="A ORDEN DE PAGO" disabled>
                      A Orden de Pago
                    </option>
                    <option value="LIQUIDADO">Liquidado</option>
                  </>
                ) : (
                  <>
                    <option value="CIERRE">Cierre</option>
                    <option value="ENVIADOPRESTADOR">Enviado a Prestador</option>
                    <option value="ENVIADOUSUARIO">Enviado a Usuario</option>
                    <option value="A ORDEN DE PAGO">A Orden de Pago</option>
                    <option value="LIQUIDADO">Liquidado</option>
                  </>
                )}
              </select>
            </div>
          </div>

          {/* Nuevo campo Fecha para Orden de Pago */}
          <div className="form-group mb-2 row">
            <label className="col-form-label">
              Fecha para Orden de Pago
              <span className="text-danger">*</span>
            </label>
            <div>
              <input
                type="date"
                className="form-control"
                required
                value={formData3.fechaordenpago}
                onChange={(e) =>
                  setValue({ ...formData3, fechaordenpago: e.target.value })
                }
              />
            </div>
          </div>

          <div className="form-group mb-2 row">
            <label className="col-form-label">
              Factura Numero
              <span className="text-danger">*</span>
            </label>
            <div>
              <input
                type="text"
                className="form-control"
                required
                minLength="10"
                value={formData3.facturanumero}
                onChange={(e) =>
                  setValue({ ...formData3, facturanumero: e.target.value })
                }
              />
            </div>
          </div>
          <div className="form-group mb-2 row">
            <label className="col-form-label">
              Monto Factura
              <span className="text-danger">*</span>
            </label>
            <div>
              <input
                type="number"
                className="form-control"
                required
                value={formData3.montoliquidado}
                onChange={(e) =>
                  setValue({ ...formData3, montoliquidado: e.target.value })
                }
              />
            </div>
          </div>
          <div className="form-group mb-2 row">
            <label className="col-form-label">
              Obs.
              <span className="text-danger">*</span>
            </label>
            <div>
              <textarea
                className="form-control"
                required
                value={formData3.obs}
                onChange={(e) =>
                  setValue({ ...formData3, obs: e.target.value })
                }
              />
            </div>
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="danger" onClick={onCloseModal}>
          Cerrar
        </Button>
        <Button onClick={handleSubmit2}>
          Guardar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalLiquidar;
